import React from 'react'
import './css/numberSliderCss.css'
import sizeType from '../util/sizeStyle'

import CustomSlider from './slider'

const NumberSlider = ({
  item,
  value,
  validationMessage,
  handleChange,
  handleFocus,
  handleBlur,
  handleKeyPress,
  defaultValue,
  formData,
}) => {
  const disabled = typeof item.disabled === 'function' ? item.disabled(formData) : item.disabled || false
  const inputValue = Number(value) || Number(defaultValue) || Number(item.min) || 0

  const min = item.min || 0

  const changeValue = (val) => {
    if (handleChange) {
      const decimalCount = item.decimal || 0
      const parsedValue = parseFloat(Number(val).toFixed(decimalCount))
      handleChange(parsedValue, item.name)
    }
  }
  // Return Input in view
  return (
    <div className={`${sizeType[item.size]} !p-0 flex w-full gap-sm`}>
      <input
        name={item.name}
        type={'number'}
        placeholder={item.placeholder}
        disabled={disabled}
        className={`transition outline-none text-center
                    ${item.disabled && 'disabled'}  
                    text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                    placeholder:text-gray-400 placeholder:text-text-md
                    focus:shadow-focus focus:border-primary-500
                    hover:border-primary-500 
                    !w-[70px] shadow-xs
                    ${sizeType[item.size]}
                    ${item.innerClassName || ''} 
                    ${validationMessage ? 'border-red-500 border-2' : ''}`}
        value={inputValue ? String(inputValue)?.replace(/^0+/, '') : 0}
        min={min}
        onChange={(e) => {
          let val = e.target.value
          if (val < min) {
            val = min
          }
          if (item.max !== undefined && val > item.max) {
            val = item.max
          }
          changeValue(val)
        }}
        onFocus={(e) => {
          if (handleFocus) handleFocus(e.target.value, item.name)
        }}
        onBlur={(e) => {
          if (handleBlur) handleBlur(e.target.value, item.name)
        }}
        onKeyPress={(e) => {
          if (handleKeyPress) handleKeyPress(e)
        }}
        autoFocus={item?.autoFocus}
      />
      <CustomSlider min={min} max={item.max || 100} change={changeValue} defaultValue={value} />
    </div>
  )
}

export default NumberSlider
